module.exports = __webpack_public_path__ + "static/biz-bulk-8683e21a97cc66d72e55fe7f33068c67.jpg";